var initializeGalleryBlock = function(block){
	
	setupGalleryCarousel(block);
	setupGalleryPagination(block);

}

function setupGalleryCarousel(block) {
	
	jQuery('.remodal.gallery-block .slick:not(.slick-initialized)').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: true
	});
	
	jQuery(document).on('opening', '.remodal', function(){
		setTimeout(function(){
			jQuery('.remodal.gallery-block .slick').slick("refresh");
		}, 50);
	});
	
	jQuery(".plumb-columns a", block).on('click', function(){
		
		var current = jQuery(this);
		var index = current.index();
		var remodalID = current.attr("data-remodal-target");
		
		jQuery('.remodal.gallery-block[data-remodal-id="' + remodalID + '"] .slick').slick("slickGoTo", index);
		
	});
	
}

function setupGalleryPagination(block) {
	
	var photosPerPage = jQuery(".gallery-container", block).data("photos-per-page");
	var photosToAddEachClick = 100;
	var currentShowing = photosPerPage;
	
	jQuery("a.more", block).on("click", function(){
		
		for(var i=currentShowing; i<currentShowing+photosToAddEachClick; i++) {
			jQuery(".plumb-columns > a:eq(" + i + ")", block).removeClass("hide");
		}
		
		if(!jQuery("a.item.hide", block).length) {
			jQuery("a.more", block).addClass("hide");
		}
		
		console.log(jQuery("a.hide", block).length);
		
		jQuery("a.close", block).removeClass("hide");
		
		currentShowing += photosToAddEachClick;
		
	});
	
	jQuery("a.close", block).on("click", function(){
		
		currentShowing = photosPerPage
		
		jQuery(".plumb-columns > a", block).addClass("hide");
		jQuery("a.close", block).addClass("hide");
		jQuery("a.more", block).removeClass("hide");
		
		for(var i=0; i<currentShowing; i++) {
			jQuery(".plumb-columns > a:eq(" + i + ")", block).removeClass("hide");
		}
		
	});
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-gallery').each(function(){
		initializeGalleryBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=gallery', initializeGalleryBlock);
